import videojs from 'video.js';
import 'video.js/dist/video-js.css';

document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('.js-video');
  const Uis = document.querySelectorAll('.js-videoUi');

  videos.forEach((video) => {
    videojs(video, {
      disablePictureInPicture: true, // PiPを無効化
      disableDocumentPictureInPicture: true, // PiPを無効化
      playsinline: true, // インライン再生
    });

    const player = video.querySelector('video');
    if (player) {
      player.addEventListener('pause', function () {
        Uis.forEach((ui) => {
          ui.classList.remove('is-hidden');
        });
      });

      player.addEventListener('play', function () {
        Uis.forEach((ui) => {
          ui.classList.add('is-hidden');
        });
      });
    }
  });
});
